import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Import Model
import { apiLink } from "../../../constant/api-link";
import { LocalStorageService } from "angular-2-local-storage";
import { ProjectProductModel } from "../../../model/builk/coupon/project-product.model";
import { CouponItemModel, CouponListModel, CreateProjectCouponModel } from "../../../model/builk/coupon/project-coupon.model";
import { CreateImageTipModel, ImageTipListModel, ImageTipListQueryModel } from "../../../model/builk/image-tip/image-tip.model";

@Injectable({
    providedIn: "root"
})
export class ImageTipService {

    constructor(
        private http: HttpClient,
        private localStorageService: LocalStorageService
    ) { }

    sub: any;

    getImageTips(query: ImageTipListQueryModel): Observable<ImageTipListModel> {
        const url = apiLink.getImageTips;
        const headers = new HttpHeaders({ "Content-Type": "application/json" });

        return this.http.get<ImageTipListModel>(url, { headers });
    }

    createImageTip(model: CreateImageTipModel): Observable<boolean> {

        const url = apiLink.createImageTip;
        // const headers = new HttpHeaders({ "Content-Type": "application/json" });
        let form = new FormData();
        
        form.append('title', model.title);
        form.append('linkUrl', model.linkUrl);
        form.append('userSurrKey', model.userSurrKey.toString());
        form.append('file', model.file);
        return this.http.post<boolean>(url, form);
    }
}
